import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 pl-2.5 static" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/sidebar/home-solutions.svg",
  class: "w-6 pb-1"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Soluções", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/sidebar/sidebar-services.svg",
  class: "w-6 pb-1"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Serviços", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/sidebar/sidebar-support.svg",
  class: "w-6 pb-1"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Suporte", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "flex flex-col items-center oi" }
const _hoisted_12 = { class: "pt-9 w-52 text-center pb-9 font-bold" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Como você prefere receber o seu atendimento?")
const _hoisted_14 = { class: "flex items-center gap-5" }
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", { class: "w-32 h-28 rounded-lg bg-indigo-50 flex flex-col items-center justify-center gap-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/icon/sidebar/sidebar-freesupportemail.svg",
    class: "w-6"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-sm" }, [
    /*#__PURE__*/_createTextVNode(" Suporte Grátis "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" por e-mail ")
  ])
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "w-32 h-28 rounded-lg bg-indigo-50 flex flex-col items-center justify-center gap-1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-sm" }, [
  /*#__PURE__*/_createTextVNode(" Suporte Premium "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" via WhatsApp ")
], -1)

import { onMounted, ref } from "vue";
import {
	IonContent,
	IonModal,
	IonLabel,
	useIonRouter,
	menuController,
} from "@ionic/vue";
import { logoWhatsapp } from "ionicons/icons";
import api from "@/services/api/api";


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceButtons',
  setup(__props) {

const openModal = ref(false);
const setOpenModal = (value: boolean) => {
	openModal.value = value;
};
const ionRouter = useIonRouter();

const supportNumber = ref();
const supportEmail = ref();

const handleOpenRoute = async (route: string) => {
	await menuController.close();
	ionRouter.push(route);
};

onMounted(async () => {
	supportNumber.value = await api.getInternalContactsSort("SUPPORT");
	supportEmail.value = await api.getInternalEmailsSort("SUPPORT");
	supportNumber.value = supportNumber.value.contact.contact;
	supportEmail.value = supportEmail.value.email.email;
});

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "w-[85px] h-20 rounded-lg bg-sky-100 flex flex-col items-center justify-center",
      tab: "solutions",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleOpenRoute('/solutions')), ["prevent"]))
    }, _hoisted_4),
    _createElementVNode("button", {
      class: "w-[85px] h-20 rounded-lg bg-sky-100 flex flex-col items-center justify-center",
      tab: "services",
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleOpenRoute('/services')), ["prevent"]))
    }, _hoisted_7),
    _createElementVNode("button", {
      class: "w-[85px] h-20 rounded-lg bg-sky-100 flex flex-col items-center justify-center",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (setOpenModal(true)))
    }, _hoisted_10),
    _createVNode(_unref(IonModal), {
      "initial-breakpoint": 0.35,
      breakpoints: [0, 0.35],
      "is-Open": openModal.value,
      onDidDismiss: _cache[3] || (_cache[3] = ($event: any) => (setOpenModal(false)))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonContent), null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    href: `mailto:${supportEmail.value}`
                  }, _hoisted_17, 8, _hoisted_15)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    href: `https://api.whatsapp.com/send?phone=${supportNumber.value}`
                  }, [
                    _createElementVNode("button", _hoisted_19, [
                      _createVNode(_component_ion_icon, {
                        class: "text-2xl text-[#009ee2]",
                        icon: _unref(logoWhatsapp)
                      }, null, 8, ["icon"]),
                      _hoisted_20
                    ])
                  ], 8, _hoisted_18)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["initial-breakpoint", "breakpoints", "is-Open"])
  ]))
}
}

})